var map = {
	"./Mask.png": 103,
	"./Spainsunderwatersuperplant.jpg": 9595,
	"./SpainsunderwatersuperplantDesktop.jpg": 6012,
	"./arevivalofegyptsnubianculture.jpg": 4408,
	"./saudi_arabia-saudi-lineage.jpg": 4792,
	"./theworldshardestcheese.jpg": 8987
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5978;